import { createTransform } from 'redux-persist';
import { Metadata } from '../models/metadata';

export const metadataTransformer = createTransform(
  (inboundState) => {
    const object = inboundState?.object?.toJSON?.();
    const metaPricing = {
      ...object,
      promoted_bank_name: undefined,
      program_discount: undefined,
      voucher_discount: undefined,
      final_price_after_taxes: undefined,
    };
    return { ...inboundState, object: metaPricing };
  },
  (outboundState) => {
    return { ...outboundState, object: new Metadata(outboundState?.object) };
  },
  {
    whitelist: ['metadata'],
  },
);
